import CascadeRequestPayload from "slotworks/model/gameplay/requests/cascade-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contracts/contract";

export function LoadCascadeCommand(): Contract<void> {
    const payload = new CascadeRequestPayload();

    return CommsManager.request(payload);
}
